module.exports = __webpack_public_path__ + "static/media/image-006n.706731c8.jpeg";